import { render, staticRenderFns } from "./OrganizationalUnit.vue?vue&type=template&id=21027e9b&scoped=true"
import script from "./OrganizationalUnit.vue?vue&type=script&lang=js"
export * from "./OrganizationalUnit.vue?vue&type=script&lang=js"
import style0 from "./OrganizationalUnit.vue?vue&type=style&index=0&id=21027e9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21027e9b",
  null
  
)

export default component.exports